import { makeStyles, Paper, Tab, Tabs } from "@material-ui/core";
import React from "react";
import Approve from "./Approve";
import Reject from "./Reject";
import "./Req.css";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
    padding: "10px",
  },
  formControl: {
    minWidth: 145,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Closed = () => {
  const classes = useStyles();
  const [values, setValues] = React.useState(0);
  const handleChanges = (event, newValue) => {
    setValues(newValue);
  };

  return (
    <div className="adminTReq">
      <div>
        <Paper className={classes.root} style={{ margin: "20px 0px" }}>
          <Tabs
            value={values}
            onChange={handleChanges}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Accepted" className="tab" />
            <Tab label="Rejected" className="tab" />
          </Tabs>
        </Paper>
      </div>
      {values === 1 && <Reject />}
      {values === 0 && <Approve />}
    </div>
  );
};

export default Closed;
